/**
 * @param {string} html
 * @returns {*}
 */
function includeFragment (html) {
  if (!html) return

  return html
    .replace(/<div[^>]*?data-ssi="true"[^>]*?data-url="([^"]*?)"[^>]*?><\/div>/gi, (match, url) => {
      return `<div style="width: 100%;"><!--# include file="${url}" --></div>`
    })
    .replace(/<div[^>]*?data-ssr="true"[^>]*?data-url="([^"]*?)"[^>]*?><\/div>/gi, (match, url) => {
      return `<div style="width: 100%;"><!--# include virtual="${url}" wait="yes" --></div>`
    })
}

module.exports = { includeFragment }
